import { forwardRef, useId, type InputHTMLAttributes } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label: string
  hint?: string | undefined
  error?: string | undefined
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, id: providedId, label, hint, error, ...props },
  ref,
) {
  const generatedId = useId()
  const id = providedId ?? generatedId
  const messageId = hint || error ? `${id}-message` : undefined

  return (
    <div className="ds-field">
      <label className="ds-field__label" htmlFor={id}>
        {label}
      </label>
      <input
        ref={ref}
        id={id}
        className={mergeClassNames('ds-input', error && 'ds-input--error', className)}
        aria-describedby={messageId}
        aria-invalid={Boolean(error)}
        {...props}
      />
      {error ? (
        <span id={messageId} className="ds-field__message ds-field__message--error">
          {error}
        </span>
      ) : hint ? (
        <span id={messageId} className="ds-field__message">
          {hint}
        </span>
      ) : null}
    </div>
  )
})
